import React, { useState } from "react";

import { Order } from "@/types";
import OrderDocumentsTable from "@/components/organisms/OrderDocumentsTable";
import { DEFAULT_ORDER_DOCUMENTS_COLUMN } from "@/components/organisms/OrderDocumentsTable/const/default";
import Accordion from "@/components/organisms/AccordionDrawer";
import { useTranslation } from "react-i18next";
import DocumentTable from "@/components/organisms/DocumentTable";
import { ORDER_DRAWER_DOCUMENTS_COLUMN } from "@/components/organisms/DocumentTable/const/order-drawer";
import { Grid, Group } from "@mantine/core";
import CTA from "@/components/atoms/CTA";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { attachDocumentsFromArhiveToOrder } from "@/services/Orders";

interface DocumentsTabContentProps {
  order: Order;
}

const DocumentsTabContent: React.FC<DocumentsTabContentProps> = ({ order }) => {
  const { t } = useTranslation();
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const queryClient = useQueryClient();

  const { mutate: addDocumentsToOrder } = useMutation({
    mutationFn: async () => {
      return await attachDocumentsFromArhiveToOrder(order.id, selectedRows);
    },
    onError: () => {},
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["getTransactionInvoices"] }),
        queryClient.invalidateQueries({ queryKey: ["getDeviationInvoice"] }),
        queryClient.invalidateQueries({ queryKey: ["getTransactionDocIds"] }),
        queryClient.invalidateQueries({ queryKey: ["getDocumentById"] }),
        queryClient.invalidateQueries({ queryKey: ["orderAttachments"] }),
      ]);
    },
  });

  return (
    <>
      <Accordion initiallyOpen title={t("orders:attachedDocuments")}>
        <Grid p={20}>
          <Grid.Col>
            <OrderDocumentsTable order={order} visibleColumns={DEFAULT_ORDER_DOCUMENTS_COLUMN} />
          </Grid.Col>
        </Grid>
      </Accordion>

      <Accordion title={t("orders:attachDocuments")}>
        <Grid p={20}>
          <Grid.Col>
            <DocumentTable
              selectable={true}
              visibleColumns={ORDER_DRAWER_DOCUMENTS_COLUMN}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
          </Grid.Col>
          <Grid.Col>
            <Group justify="flex-end">
              <CTA intent="primary" onClick={() => addDocumentsToOrder()}>
                {t("actions:attachSelected")}
              </CTA>
            </Group>
          </Grid.Col>
        </Grid>
      </Accordion>
    </>
  );
};

export default DocumentsTabContent;
